import { apiFetch } from './apiClient';
import { FormFieldApiInput, FormSubmission, LeadForm, LeadFormApi, LeadFormField, LeadFormInput } from '../types/leadForms';

const BASE = '/api/v1/admin/forms';

// export const leadFormsApi = {
//   getForms: () => apiFetch<LeadForm[]>(BASE),
//   getForm: (id: string) => apiFetch<LeadFormApi>(`${BASE}/${id}`),
//   createForm: (data: LeadFormInput) => apiFetch<LeadForm>(BASE, { method: 'POST', body: JSON.stringify(data) }),
//   updateForm: (id: string, data: LeadFormInput) => apiFetch<LeadForm>(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
//   deleteForm: (id: string) => apiFetch<void>(`${BASE}/${id}`, { method: 'DELETE' }),
//   createField: (formId: string, data: FormFieldApiInput) => apiFetch<LeadFormField>(`${BASE}/${formId}/fields`, { method: 'POST', body: JSON.stringify(data) }),
//   updateField: (formId: string, fieldId: string, data: FormFieldApiInput) => apiFetch<LeadFormField>(`${BASE}/${formId}/fields/${fieldId}`, { method: 'PUT', body: JSON.stringify(data) }),
//   deleteField: (formId: string, fieldId: string) => apiFetch<void>(`${BASE}/${formId}/fields/${fieldId}`, { method: 'DELETE' }),
//   moveFieldUp: (formId: string, fieldId: string) => apiFetch<LeadForm>(`${BASE}/${formId}/fields/${fieldId}/move-up`, { method: 'POST' }),
//   moveFieldDown: (formId: string, fieldId: string) => apiFetch<LeadForm>(`${BASE}/${formId}/fields/${fieldId}/move-down`, { method: 'POST' }),
//   getPublicForm: (slug: string) =>
//   apiFetch<LeadForm>(
//     `/form/${slug}`
//   ),

//   getSubmissions: (formId: string) =>
//     apiFetch<FormSubmission[]>(
//       `/forms/${formId}/submissions`
//   ),

//   submitPublicForm: (
//     slug: string,
//     data: Record<string, unknown>
//   ) =>
//     apiFetch(
//       `/form/${slug}/submit`,
//       {
//         method: 'POST',
//         body: JSON.stringify(data),
//       }
//     ),
//   };
export const leadFormsApi = {
  getForms: () =>
    apiFetch<LeadForm[]>(BASE),

  getForm: (id: string) =>
    apiFetch<LeadFormApi>(`${BASE}/${id}`),

  createForm: (data: LeadFormInput) =>
    apiFetch<LeadForm>(BASE, {
      method: 'POST',
      body: JSON.stringify(data),
    }),

  updateForm: (
    id: string,
    data: LeadFormInput
  ) =>
    apiFetch<LeadForm>(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  deleteForm: (id: string) =>
    apiFetch<void>(`${BASE}/${id}`, {
      method: 'DELETE',
    }),

  createField: (
    formId: string,
    data: FormFieldApiInput
  ) =>
    apiFetch<LeadFormField>(
      `${BASE}/${formId}/fields`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      }
    ),

  updateField: (
    formId: string,
    fieldId: string,
    data: FormFieldApiInput
  ) =>
    apiFetch<LeadFormField>(
      `${BASE}/${formId}/fields/${fieldId}`,
      {
        method: 'PUT',
        body: JSON.stringify(data),
      }
    ),

  deleteField: (
    formId: string,
    fieldId: string
  ) =>
    apiFetch<void>(
      `${BASE}/${formId}/fields/${fieldId}`,
      {
        method: 'DELETE',
      }
    ),

  moveFieldUp: (
    formId: string,
    fieldId: string
  ) =>
    apiFetch<LeadForm>(
      `${BASE}/${formId}/fields/${fieldId}/move-up`,
      { method: 'POST' }
    ),

  moveFieldDown: (
    formId: string,
    fieldId: string
  ) =>
    apiFetch<LeadForm>(
      `${BASE}/${formId}/fields/${fieldId}/move-down`,
      { method: 'POST' }
    ),

  getSubmissions: (formId: string) =>
    apiFetch<FormSubmission[]>(
      `${BASE}/${formId}/submissions`
    ),

  getPublicForm: (slug: string) =>
    apiFetch<LeadForm>(
      `/form/${slug}`
    ),

  submitPublicForm: (
    slug: string,
    data: Record<string, unknown> & { captchaToken: string }
  ) =>
    apiFetch(
      `/form/${slug}/submit`,
      {
        method: 'POST',
        body: JSON.stringify(data),
      }
    ),
};